(async () => {
    const { Core } = await importModule('Core');
    const { $clone } = await importModule('Utils');

    const SEL_INPUT = '[data-input]';

    customElements.define('product-qty-selector', class extends Core {
        elements = {
            selector: '[data-selector-wrapper]',
            inputTemplate: '[data-input-template]',
            input: '[data-input]'
        }
        render() {
            this.$selector?.addEventListener('change', this._onQtyChange.bind(this));
            this.$input?.addEventListener('input', this._onQtyChangeInput.bind(this));
            this.$input?.addEventListener('change', this._onQtyChangeInput.bind(this))
        }
        _onQtyChange(e) {
            if (+e.target.value === 10) this._changeInputType();
        }
        _onQtyChangeInput(e) {
            if(+e.target.value > +e.target.getAttribute("max")){
              e.target.value = +e.target.getAttribute("max");
            } 
        }
        _changeInputType() {
            this.replaceChild($clone(this.$inputTemplate), this.$selector);
            this.querySelector(SEL_INPUT).setAttribute('value', 10);
        }        
    })
})();
